<template>
  <div :class="'dashboard__replies__crew p-4 mark-' + index">
    <div class="offset" :style="'height: 32px'"></div>
    <div v-if="!questionnaire.summarySheet" class="mark__replies">
      <div>
        <span v-if="findProfileMark(1)">{{ findProfileMark(1) }}</span>
        <span v-else> <FontAwesomeIcon icon="fa-light fa-hourglass-start" /></span>
      </div>
      <div>
        <span v-if="findProfileMark(2)">{{ findProfileMark(2) }}</span>
        <span v-else> <FontAwesomeIcon icon="fa-light fa-hourglass-start" /></span>
      </div>
      <div>
        <span v-if="findProfileMark(3)">{{ findProfileMark(3) }}</span>
        <span v-else> <FontAwesomeIcon icon="fa-light fa-hourglass-start" /></span>
      </div>
      <div>
        <span v-if="findProfileMark(4)">{{ findProfileMark(4) }}</span>
        <span v-else> <FontAwesomeIcon icon="fa-light fa-hourglass-start" /></span>
      </div>
    </div>
    <div v-else class="mark__replies d-flex align-items-center justify-content-center">
      <span v-if="findSummarySheetMark()">{{ findSummarySheetMark() }}</span>
      <span v-else> <FontAwesomeIcon icon="fa-light fa-hourglass-start" /></span>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "AccordionMarkRepliesComponent",
  components: { FontAwesomeIcon },
  props: {
    index: {
      type: Number,
      required: true,
      default: 0,
    },
    questionnaire: {
      type: Object,
      required: true,
      default: null,
    },
    type: {
      type: String,
      required: true,
      default: "",
    },
  },
  methods: {
    findProfileMark(profile) {
      let mark;
      if (this.questionnaire && !this.questionnaire.summarySheet && this.questionnaire[this.type]) {
        mark = Object.values(this.questionnaire[this.type]).find((element) => element.profile === profile);
      }
      return mark?.mark ? mark?.mark : null;
    },

    findSummarySheetMark() {
      let mark;
      if (this.questionnaire && this.questionnaire.summarySheet && this.questionnaire[this.type]) {
        mark = this.questionnaire[this.type];
      }
      return mark && mark.length ? mark[0] : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard__replies__item {
  &.on {
    .mark__replies {
      width: 100px;
    }
  }
}

.mark__replies {
  height: 0;
  overflow: hidden;
  width: 0;
  transition: all 300ms ease-in-out;

  div + div {
    margin-top: 5px;
  }
}

.dashboard {
  &__replies {
    &__crew {
      min-width: 130px;
      border-bottom: 1px solid #e0e6ed;
      background-color: $lighter-grey;

      &.on {
        .mark__replies {
          padding: 20px 0;
          height: 125px;
        }
      }
    }
  }
}

.mark-0 {
  border-top: 3px solid #e0e6ed;
}
</style>
